import React, { useState, useEffect } from 'react';
import '../../css/components/Header.css';
import ProfileButton from './ProfileButton';
import ProfileSidebar from './ProfileSidebar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../firebase_service/UserContext';
import { toast } from 'react-toastify';


const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();
  
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const handleProfileClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSidebarOpen(true);
  };
  const handleSidebarClose = () => setSidebarOpen(false);
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (sidebarOpen) setSidebarOpen(false);
  };
  
  // Close mobile menu on location change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
      <div className="container header-container">
        <Link to="/" className="logo">
         
        <span className="logo-text">
        <span style={{ color: 'var(--dark-text-primary)' }}>Smart</span>
        <span style={{ 
                background: 'linear-gradient(135deg, var(--primary) 50%, var(--secondary) 100%)', 
                WebkitBackgroundClip: 'text', 
               }}>
                GPT
        </span>
        <span style={{ color: 'var(--dark-text-primary)' }}>{" TAG"}</span>
        </span>


        </Link>
        
        
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`} 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <nav className={`nav-menu ${isMobileMenuOpen ? 'show' : ''}`}>
          <ul>
            <li className="nav-item">
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                <span>Home</span>
                {location.pathname === '/' && <span className="nav-indicator"></span>}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/pricing" className={location.pathname === '/pricing' ? 'active' : ''}>
                <span>Pricing</span>
                {location.pathname === '/pricing' && <span className="nav-indicator"></span>}
              </Link>
            </li>
           
          </ul>
        </nav>
      
        <div className="header-actions">
          <button
            className="dashboard-btn"
            onClick={() => {
              if (user) {
                navigate('/dashboard');
              } else {
                toast.error('Please login first to access the dashboard.');
                setSidebarOpen(true);
              }
            }}
          >
            <span>Dashboard</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
          <ProfileButton onClick={handleProfileClick} />
          <ProfileSidebar open={sidebarOpen} onClose={handleSidebarClose} />
        </div>
      </div>
    </header>
  );
};

export default Header;